export function pageTop() {

  //PAGETOP
  $(function() {
    $('.pageTop').click(function() {
      $('html, body').animate({ scrollTop: 0 }, 800, 'swing'); // スムーススクロール
      return false; // デフォルト動作を防止
    });
  });


}